module.exports = __webpack_public_path__ + "f7fa65e54c135509a35aa13569015d44.pdf";